import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { IContatoTelefone } from "../../../../Interfaces/Geral/Contatos/ContatoTelefone/ContatoTelefoneInterface";
import LazySelect from "../../Forms/LazySelect";
import { ListarTipoTelefoneController } from "../../../../Controllers/Geral/TipoTelefone/TipoTelefoneControllers";
import { CadastrarContatoTelefoneController } from "../../../../Controllers/Geral/Contatos/ContatoTelefone/ContatoTelefoneController";
import { useCallback, useEffect, useState } from "react";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import ReactInputMask from "react-input-mask";


//campos modal ((Adicionar Contato passando as seguintes informações: TelefoneContato; TipoTel; Ramal; numTel; DDD; obs))

interface ICadastrarContatoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    idContato: number;
}

export default function CadastrarContatoTelefone(
    props: ICadastrarContatoProps
) {
    const { register, handleSubmit, formState } = useForm();
    const [dsTipoTelefoneEvent, setDsTipoTelefoneEvent] = useState("");
    const [dsTipoTelefone, setDsTipoTelefone] = useState("");
    const [ddi, setDdi] = useState("+55");
    const [ddiOutro, setDdiOutro] = useState("");

    function handleCadastrarContatoFormSubmit(formData: IContatoTelefone) {
        CadastrarContatoTelefoneController({
            ...formData,
            ID_CONTATO: props.idContato,
            DS_TIPO_TELEFONE: dsTipoTelefone,
            COD_DDI: ddiOutro.length ? ddiOutro.replace("_","") : ddi
        }).then(() => {
            props.setShow(false);
            props.update();
        });
    }

    const { value: listarTipoTelefone } = useAsyncEffect(() =>
        ListarTipoTelefoneController()
    );

    const handleDsTipoTelefone = useCallback(() => {
        listarTipoTelefone?.filter((f) => {
            if (f.ID_TIPO_TELEFONE === Number(dsTipoTelefoneEvent)) {
                return setDsTipoTelefone(f.DS_TIPO_TELEFONE);
            } else {
                return false;
            }
        });
    }, [listarTipoTelefone, dsTipoTelefoneEvent]);

    useEffect(() => {
        handleDsTipoTelefone();
    }, [handleDsTipoTelefone]);
    return (
        <form
            className="w-100 align-itens-center mt-5 row m-0"
            onSubmit={handleSubmit(handleCadastrarContatoFormSubmit)}
        >
            <div className="col-12 col-lg-4 mt-2">
                <label>DDI: *</label>
                <select
                    name="COD_DDI"
                    className="form-control"
                    value={ddi}
                    onChange={(e) => setDdi(e.target.value)}
                >
                    <option value="+55">+55 (Brasil)</option>
                    <option value="+1">+1 (EUA)</option>
                    <option value="outro">Outro</option>
                </select>
            </div>
            {ddi === "outro" &&
                <div className="col-12 col-lg-4 mt-2">
                    <label>DDI: *</label>
                    <ReactInputMask
                    type="tel"
                    className={"form-control placeholder-dark-50"}
                    placeholder={"DDI"}
                    max={3}
                    mask={"+999"}
                    onChange={(e) => {
                        setDdiOutro(e.target.value);
                    }}
                    />
                </div>
            }
            <div className="col-12 col-lg-4 mt-2">
                <label>DDD: *</label>
                <input
                    type="number"
                    name="COD_DDD"
                    placeholder="DDD:"
                    className={`form-control px-0 p-2 placeholder-muted-75 ${
                        formState.errors.assunto && "is-invalid"
                    }`}
                    ref={register({
                        required: "Insira o DDD",
                    })}
                />
            </div>
            <div className="col-12 col-lg-12 mt-2">
                <label>Número do Telefone: *</label>
                <input
                    type="number"
                    name="NR_TELEFONE"
                    placeholder={"Digite o número do telefone:"}
                    className={`form-control px-0 p-2 placeholder-muted-75`}
                    ref={register({
                        required: "Insira o número",
                    })}
                />
            </div>
            <div className="col-12 col-lg-6 mt-2">
                <label>Tipo do Telefone: *</label>
                <LazySelect
                    controller={ListarTipoTelefoneController}
                    getDS={(tt) => tt.DS_TIPO_TELEFONE}
                    getKeyValue={(tt) => tt.ID_TIPO_TELEFONE}
                    name="ID_TIPO_TELEFONE"
                    placeholder={"Digite o TIPO do telefone"}
                    className={`form-control px-0 p-2 placeholder-muted-75 `}
                    onChange={(e) => setDsTipoTelefoneEvent(e.target.value)}
                    ref={register({
                        required: "Insira o tipo",
                    })}
                >
                    <option></option>
                </LazySelect>
            </div>
            <div className="col-12 col-lg-6 mt-2">
                <label>Adicionar Ramal:</label>
                <input
                    type="text"
                    name="NR_RAMAL"
                    placeholder={"Digite o Ramal"}
                    className={`form-control px-0 p-2 placeholder-muted-75`}
                    ref={register()}
                />
            </div>

            <div className="col-12">
                <label>Observações para o Contato:</label>
                <input
                    type="text"
                    name="DS_OBS"
                    placeholder="Obs:"
                    className={`form-control px-0 p-2 placeholder-muted-75 ${
                        formState.errors.assunto && "is-invalid"
                    }`}
                    ref={register()}
                />
            </div>

            <div className="col-12">
                <button className="btn btn-sm btn-success w-100 mt-5">
                    <div className="toClick-component">
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />{" "}
                        Adicionar Telefone
                    </div>
                </button>
            </div>
        </form>
    );
}
